import { Component, OnDestroy } from '@angular/core';
import { IonicPage, ModalController, Refresher } from 'ionic-angular';
import { Subject } from 'rxjs';

import { AppModeProvider } from '../../providers/app-mode/app-mode';
import { FleetPage } from '../fleet/fleet';
import { OpsProvider } from '../../providers/ops/ops';
import { OrderListPage } from './../order-list/order-list';
import { ShiftPage } from '../shift/shift';
import { TruckModel } from '../../models/truck';
import { UserModel } from '../../models/user';
import { UserProvider } from '../../providers/user/user';

@IonicPage()
@Component({
  selector: 'page-ops-tabs',
  templateUrl: 'ops-tabs.html',
})
export class OpsTabsPage implements OnDestroy {
  openPage = OrderListPage;
  completedPage = OrderListPage;
  fleetPage = FleetPage;
  openPageParams = { orderType: 'pending' };
  completedPageParams = { orderType: 'completed' };
  pendingOrderCount = 0;
  truck: TruckModel;
  user: UserModel;
  refresher: Refresher;
  greetingText: string;
  readonly noServiceInstruction =
    'Select a service vehicle and clock in to see your orders.';

  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private appMode: AppModeProvider,
    private modalCtrl: ModalController,
    private opsService: OpsProvider,
    private userService: UserProvider
  ) {
    this.loadData();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private loadData() {
    this.opsService.loadSelectedTruck();
    this.opsService.selectedTruck$
      .takeUntil(this.unsubscribe)
      .subscribe((truck: TruckModel) => (this.truck = truck));
    this.userService.currentUser$
      .takeUntil(this.unsubscribe)
      .subscribe(user => {
        this.user = user;
        this.greetingText =
          this.user && this.user.firstName
            ? `Hello ${this.user.firstName}!`
            : `Hello!`;
      });
    this.opsService.openOrderCount$
      .takeUntil(this.unsubscribe)
      .subscribe(count => {
        this.pendingOrderCount = count;
      });
  }

  // Actions

  didTapStartButton() {
    let modal = this.modalCtrl.create(ShiftPage);
    modal.present();
  }

  didTapSwitchToMain() {
    this.appMode.showModeSwitchingActionSheet();
  }
}



// WEBPACK FOOTER //
// ./src/pages/ops-tabs/ops-tabs.ts